import { render } from "./HealthEducation.vue?vue&type=template&id=7d86db2b&scoped=true"
import script from "./HealthEducation.vue?vue&type=script&lang=js"
export * from "./HealthEducation.vue?vue&type=script&lang=js"

import "./HealthEducation.vue?vue&type=style&index=0&id=7d86db2b&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d86db2b"]])

export default __exports__